import {FILTER_DATA, RESET_DATA} from "./searchBox.types";

export const filterData = (input) => ({
  type: FILTER_DATA,
  payload: input
});
export const resetData = () => ({
  type: RESET_DATA
});